import { createRouter, createWebHashHistory } from "vue-router";
import MainView from "../views/MainView.vue";
import Menu1 from "../views/Menu1View/index.vue";
import LoginView from "../views/LoginView.vue";
import ResetPasswordView from "../views/ResetPasswordView/index.vue";
import MenuProject from "../views/ProjectView/index.vue";
import MenuEditProject from "../views/EditProjectView/index.vue";
import MenuNeighbor from "../views/NeighborView/index.vue";
import MenuEquipment from "../views/EquipmentView/index.vue";
import EditUser from "../views/EditUserView/index.vue";
import Members from "../views/MembersView/index.vue";
import Guide from "../views/GuideView/index.vue";
import Accessibility from "../views/AccessibilityView/index.vue";
import Report from "../views/ReportView/index.vue";
import MenuMitigation from "../views/MitigationView/index.vue";
import ApproveView from "../views/ApproveView.vue";
import AdminView from "../views/AdminView/index.vue";
import SelectionView from "../views/SelectionView/index.vue";
import MenuCenterPoint from "../views/CenterPointView/index.vue";
import NotionalDistanceView from "../views/NotionalDistanceView/index.vue";
import store from "../store/index";
import CryptoHelper from "@/helper/CryptoHelper";

function hasCurrentProject(to, from, next) {
  if (store.getters.currentProject?.id) {
    next();
  } else {
    next("/");
  }
}

const routes = [
  /*{
    path: '/',
    name: 'home',
    component: HomeView
  },*/
  {
    path: "/",
    name: "home",
    component: MainView,
    children: [
      {
        path: "/Menu1",
        name: "menu1",
        component: Menu1,
      },
      {
        path: "/Projects",
        name: "projects",
        component: MenuProject,
      },
      {
        path: "/EditProjects",
        name: "editProjects",
        component: MenuEditProject,
        beforeEnter: hasCurrentProject,
      },
      {
        path: "/CenterPoint",
        name: "centerpoint",
        component: MenuCenterPoint,
        beforeEnter: hasCurrentProject,
      },
      {
        path: "/Neighbor",
        name: "neighbor",
        component: MenuNeighbor,
        beforeEnter: hasCurrentProject,
      },
      {
        path: "/Equipment",
        name: "equipment",
        component: MenuEquipment,
        beforeEnter: hasCurrentProject,
      },
      {
        path: "/EditUser",
        name: "editUser",
        component: EditUser,
      },
      {
        path: "/Members",
        name: "members",
        component: Members,
      },
      {
        path: "/Guide",
        name: "guider",
        component: Guide,
      },
      {
        path: "/Accessibility",
        name: "accessibility",
        component: Accessibility,
      },
      {
        path: "/Report",
        name: "report",
        component: Report,
        beforeEnter: hasCurrentProject,
      },
      {
        path: "/Mitigation",
        name: "mitigation",
        component: MenuMitigation,
        beforeEnter: hasCurrentProject,
      },
      {
        path: "/Mitigation/:page",
        name: "mitigation",
        component: MenuMitigation,
        beforeEnter: hasCurrentProject,
      },
      {
        path: "/Select",
        name: "selection",
        component: SelectionView,
        beforeEnter: hasCurrentProject,
      },
      {
        path: "/NotionalDistance/:buildingid",
        name: "notionalDistance",
        component: NotionalDistanceView,
        beforeEnter: hasCurrentProject,
      },
    ],
  },
  {
    path: "/Login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/Reset",
    name: "reset",
    component: ResetPasswordView,
  },
  {
    path: "/UserApproval",
    name: "approve",
    component: ApproveView,
  },
  {
    path: "/Admin",
    name: "admin",
    component: AdminView,
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: function () {
  //     return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  //   }
  // }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
